import LegalLayout, { LegalSection, LegalList } from "../../components/chalk/LegalLayout";

export default function CommunityPolicy() {
  return (
    <LegalLayout title="Community Policy" eyebrow="Legal" lastUpdated="February 2026" testId="page-community-policy">
      <LegalSection heading="What we expect">
        <p>
          Chalk OS exists so coaches and families can run a team without chaos. We expect every coach,
          guardian, athlete, league admin, and volunteer to treat the platform — and each other — with
          the same care they would expect on the field.
        </p>
      </LegalSection>

      <LegalSection heading="What's not allowed">
        <LegalList items={[
          "Harassment, threats, or bullying directed at any coach, parent, athlete, official, or volunteer.",
          "Discriminatory content based on race, ethnicity, national origin, religion, sex, gender, sexual orientation, disability, or any protected category.",
          "Inappropriate messages — including sexually suggestive content directed at minors — under any circumstance.",
          "Spam, repeated unsolicited messages, or off-topic promotional content.",
          "Impersonation of another coach, guardian, athlete, league, or organization.",
          "Misuse of athlete data, including using roster contacts for purposes outside the team.",
          "Sharing another family's private information outside the app.",
          "Uploading unsafe, illegal, explicit, or unrelated files.",
        ]} />
      </LegalSection>

      <LegalSection heading="Enforcement">
        <p>
          Chalk OS may remove content, restrict accounts, or suspend access for misuse. Severe or
          repeated violations may result in permanent account termination. Reports involving safety
          concerns are prioritized.
        </p>
      </LegalSection>

      <LegalSection heading="Reporting a problem">
        <p>
          To report a violation, email{" "}
          <a href="mailto:support@getchalkos.com" style={{ color: "#2E7D52" }}>support@getchalkos.com</a>{" "}
          with the team name, the message or file at issue, and the date it occurred. Reports related
          to imminent harm should also be reported to local authorities.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
